module.exports = __webpack_public_path__ + "img/電気回路_2_4_3.10399422.png";